import React from 'react'
import { Container, Typography } from '@material-ui/core'
import WaterAccessManager from './WaterAccessManager'

const WaterAccessPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f6f4' }}>
      <Container maxWidth="lg" style={{ paddingTop: 24, paddingBottom: 40 }}>
        <Typography variant="h5" style={{ fontWeight: 700, color: '#20342b', marginBottom: 8 }}>
          Water Access Points
        </Typography>
        <Typography variant="body2" style={{ color: '#5d6c64', marginBottom: 20 }}>
          Manage water refill locations for herbicide crews.
        </Typography>
        <WaterAccessManager
          apiBase="/api/water-access"
          canEdit={true}
          showNearMe={true}
        />
      </Container>
    </div>
  )
}

export default WaterAccessPage
